exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wordcloud-host[data-v-46d8389d]{position:relative;width:100%}.wordcloud[data-v-46d8389d]{width:100%;display:flex;justify-content:center;align-items:center}.wc-tooltip[data-v-46d8389d]{position:absolute;pointer-events:none;background:rgba(17,24,39,.92);color:#fff;padding:6px 10px;border-radius:6px;font-size:12px;line-height:1.2;box-shadow:0 4px 12px rgba(0,0,0,.15);white-space:nowrap;z-index:10;display:flex;gap:8px;align-items:center}.wc-tooltip-text[data-v-46d8389d]{font-weight:500}.wc-tooltip-value[data-v-46d8389d]{background:#d972a3;color:#fff;padding:1px 6px;border-radius:4px;font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46d8389d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cultura/sections/results/ResultsCloud.vue
// module id = 1911
// module chunks = 2